import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	title: {
		id: 'company-hub.resource-tiles-extension.extension-title',
		defaultMessage: 'Resource tiles',
		description:
			'Title of knowledge cards extension to be displayed in toolbar/shortcut macros dropdown.',
	},
	description: {
		id: 'company-hub.resource-tiles-extension.extension-description',
		defaultMessage: 'Showcase your documents as a set of tiles',
		description:
			'Description of resource tiles extension to be displayed in toolbar/shortcut macros dropdown',
	},
});
